/* Destination Quiz — init via initDestinationQuiz(config) from sections/destination-quiz.liquid */
window.initDestinationQuiz = function(cfg){
  "use strict";
  var ROOT = document.getElementById("dq-" + cfg.sectionId);
  if(!ROOT) return;

  function art(body, vb){
    return '<svg viewBox="' + (vb||"0 0 120 76") + '" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + body + '</svg>';
  }
  var SOLID = ' fill="currentColor" stroke="none"';
  var SOFT  = ' fill="currentColor" fill-opacity=".16"';
  var GROUND = '<path d="M6 68h108" opacity=".3"/>';

  function home(kind){
    if(kind === "apt"){
      return art(GROUND +
        '<path d="M34 12h52v56H34z"' + SOFT + '/>' +
        '<path d="M30 8h60v6H30z"' + SOLID + '/>' +
        '<rect x="41" y="20" width="11" height="8"' + SOLID + '/><rect x="56" y="20" width="11" height="8"' + SOLID + '/>' +
        '<rect x="71" y="20" width="11" height="8"' + SOLID + '/><rect x="41" y="34" width="11" height="8"' + SOLID + '/>' +
        '<rect x="56" y="34" width="11" height="8"' + SOLID + '/><rect x="71" y="34" width="11" height="8"' + SOLID + '/>' +
        '<rect x="41" y="48" width="11" height="8"' + SOLID + '/><rect x="71" y="48" width="11" height="8"' + SOLID + '/>' +
        '<path d="M38 30h48M38 44h48" opacity=".5"/><path d="M55 58h10v10H55z"/>');
    }
    if(kind === "s"){
      return art(GROUND +
        '<path d="M46 22h28v46H46z"' + SOFT + '/><path d="M43 17h34v6H43z"' + SOLID + '/>' +
        '<rect x="51" y="29" width="7" height="7"' + SOLID + '/><rect x="62" y="29" width="7" height="7"' + SOLID + '/>' +
        '<rect x="51" y="41" width="7" height="7"' + SOLID + '/><rect x="62" y="41" width="7" height="7"' + SOLID + '/>' +
        '<path d="M55 55h10v13H55z"/>');
    }
    if(kind === "m"){
      return art(GROUND +
        '<path d="M38 38h44v30H38z"' + SOFT + '/><path d="M32 38 60 18l28 20Z"' + SOLID + '/>' +
        '<rect x="45" y="45" width="9" height="9"' + SOLID + '/><rect x="66" y="45" width="9" height="9"' + SOLID + '/>' +
        '<path d="M55 56h10v12H55z"/>');
    }
    if(kind === "l"){
      return art(GROUND +
        '<path d="M20 34h50v34H20z"' + SOFT + '/><path d="M14 34 45 14l31 20Z"' + SOLID + '/>' +
        '<path d="M70 46h30v22H70z"' + SOFT + '/><path d="M66 46 85 32l19 14Z"' + SOLID + '/>' +
        '<rect x="27" y="41" width="9" height="9"' + SOLID + '/><rect x="53" y="41" width="9" height="9"' + SOLID + '/>' +
        '<path d="M39 56h11v12H39z"/><rect x="79" y="52" width="12" height="8"' + SOLID + '/>');
    }
    if(kind === "xl"){
      return art(GROUND +
        '<path d="M26 28h46v40H26z"' + SOFT + '/><path d="M20 28 49 9l29 19Z"' + SOLID + '/>' +
        '<path d="M72 42h28v26H72z"' + SOFT + '/><path d="M68 42 86 29l18 13Z"' + SOLID + '/>' +
        '<path d="M6 50h18v18H6z"' + SOFT + '/><path d="M2 50 15 40l13 10Z"' + SOLID + '/>' +
        '<rect x="33" y="36" width="9" height="9"' + SOLID + '/><rect x="56" y="36" width="9" height="9"' + SOLID + '/>' +
        '<path d="M43 55h12v13H43z"/><rect x="80" y="49" width="12" height="8"' + SOLID + '/>');
    }
    return art(GROUND +
      '<path d="M16 21h88v47H16z"' + SOFT + '/><path d="M12 15h96v7H12z"' + SOLID + '/>' +
      '<rect x="23" y="28" width="13" height="9"' + SOLID + '/><rect x="43" y="28" width="13" height="9"' + SOLID + '/>' +
      '<rect x="63" y="28" width="13" height="9"' + SOLID + '/><rect x="83" y="28" width="13" height="9"' + SOLID + '/>' +
      '<rect x="23" y="42" width="13" height="9"' + SOLID + '/><rect x="83" y="42" width="13" height="9"' + SOLID + '/>' +
      '<path d="M46 54h28v14H46z"/><path d="M60 54v14"/><path d="M44 50h32" opacity=".5"/>');
  }

  function plan(kind){
    var rooms = {A:"M8 6h50v34H8z", B:"M58 6h54v34H58z", C:"M8 40h68v28H8z", D:"M76 40h36v28H76z"};
    var lit = {hvac:["A","B","C","D"], key:["A","B","C"], one:["A"], unsure:[]}[kind];
    var dots = {A:[[22,20],[36,15],[30,30]], B:[[74,18],[92,26],[101,14]], C:[[24,54],[42,60],[58,50]], D:[[85,54],[98,49],[103,60]]};
    var g = "", n = 0;
    Object.keys(rooms).forEach(function(k){
      g += '<path d="' + rooms[k] + '"' + (lit.indexOf(k) > -1 ? SOFT : "") + '/>';
    });
    lit.forEach(function(k){
      dots[k].forEach(function(pt){
        g += '<circle class="dq-mist" cx="' + pt[0] + '" cy="' + pt[1] + '" r="3.4"' + SOLID +
             ' opacity=".55" style="animation-delay:' + (n * 0.42).toFixed(2) + 's"/>';
        n++;
      });
    });
    if(kind === "hvac"){
      g += '<path d="M48 40H28M68 40h24M58 33V16M58 47v16" stroke-dasharray="4 4" opacity=".6"/>' +
           '<rect x="46" y="32" width="24" height="16" rx="2"' + SOLID + '/>' +
           '<path d="M52 36v8M58 36v8M64 36v8" stroke="#F5F6F6" stroke-width="2"/>';
    } else if(kind === "unsure"){
      g += '<text x="60" y="48" text-anchor="middle" font-family="DM Sans, sans-serif" font-size="30" font-weight="700"' +
           SOLID + ' opacity=".4">?</text>';
    }
    return art(g);
  }

  function calendar(days){
    var dots = "";
    var marks = Math.min(days, 9);
    for(var i=0;i<marks;i++){
      var x = 18 + (i % 3) * 28, y = 42 + Math.floor(i/3) * 12;
      dots += '<circle cx="' + x + '" cy="' + y + '" r="2.6"' + SOLID + ' opacity=".7"/>';
    }
    return art('<rect x="10" y="18" width="100" height="50" rx="3"' + SOFT + '/>' +
      '<path d="M10 32h100"/><path d="M30 10v16M90 10v16"/>' + dots);
  }

  /* destination badge: a small line-art scene of the place, in a disc frame */
  var DSOLID = ' fill="currentColor" stroke="none"';
  var DSOFT  = ' fill="currentColor" fill-opacity=".16"';
  var DEST_SCENES = {
    /* Amalfi Coast: sun, sea horizon, terraced cliffside houses, a boat */
    amalfi: '<circle cx="66" cy="30" r="5"' + DSOLID + '/>' +
      '<path d="M16 62h68" stroke-width="1.6"/>' +
      '<path d="M20 68q4-4 8 0t8 0 8 0 8 0t8 0 8 0" stroke-width="1.6" fill="none" opacity=".7"/>' +
      '<path d="M30 62V52h8v10z"' + DSOFT + '/><path d="M40 62V46h9v16z"' + DSOFT + '/>' +
      '<path d="M50 62V38h9v24z"' + DSOFT + '/><path d="M60 62V44h8v18z"' + DSOFT + '/>' +
      '<path d="M26 52h8M37 46h9M47 38h9M58 44h8" stroke-width="1.4" opacity=".55"/>' +
      '<path d="M34 80q16-6 32 0" stroke-width="1.6"/><path d="M50 80v-7" stroke-width="1.6"/>',
    /* Kyoto: three-tier pagoda flanked by bamboo */
    kyoto: '<path d="M24 36v40M28 42l-4-3-4 3M28 54l-4-3-4 3M28 66l-4-3-4 3" stroke-width="1.6"/>' +
      '<path d="M76 36v40M80 42l-4-3-4 3M80 54l-4-3-4 3M80 66l-4-3-4 3" stroke-width="1.6"/>' +
      '<path d="M50 30v6" stroke-width="1.6"/>' +
      '<path d="M38 40h24l4 6H34z"' + DSOFT + '/><path d="M40 46h20v10H40z"' + DSOFT + '/>' +
      '<path d="M35 56h30l4 6H31z"' + DSOFT + '/><path d="M38 62h24v10H38z"' + DSOFT + '/>' +
      '<path d="M31 72h38l5 7H26z"' + DSOFT + '/>',
    /* Marrakech: keyhole arch doorway, hanging lantern, palm */
    marrakech: '<path d="M36 80V58q0-18 14-18t14 18v22" stroke-width="1.8"' + DSOFT + '/>' +
      '<path d="M50 40v-8" stroke-width="1.6"/><path d="M45 32h10l-5-6z"' + DSOLID + '/>' +
      '<path d="M78 80V52" stroke-width="1.6"/>' +
      '<path d="M78 52q-10 2-10 14M78 46q8 2 8 16M78 58q-7 1-7 10M78 54q6 1 6 12" stroke-width="1.4" fill="none"/>' +
      '<path d="M22 80V44" stroke-width="1.6"/><circle cx="22" cy="38" r="4"' + DSOLID + '/>',
    /* Aspen: snow-capped peaks and pines */
    aspen: '<path d="M14 78 36 40l10 16 8-10 32 32z"' + DSOFT + '/>' +
      '<path d="M14 78 36 40l10 16 8-10 32 32" stroke-width="1.8" fill="none"/>' +
      '<path d="M30 48l6 6-6-1-6 1z"' + DSOLID + '/><path d="M46 52l5 5-5-1-5 1z"' + DSOLID + '/>' +
      '<path d="M70 72h4v6h-4zM76 68v10M66 76v2" stroke-width="1.4"/>' +
      '<path d="M70 58l6 8h-12z"' + DSOFT + '/><path d="M70 50l7 9h-14z"' + DSOFT + '/>',
    /* Santorini: whitewashed domes along a cliff, sea beyond */
    santorini: '<path d="M14 70h72" stroke-width="1.6"/>' +
      '<circle cx="76" cy="34" r="4"' + DSOLID + '/>' +
      '<rect x="22" y="58" width="16" height="12"' + DSOFT + '/><circle cx="30" cy="58" r="8"' + DSOFT + '/>' +
      '<rect x="42" y="52" width="18" height="18"' + DSOFT + '/><circle cx="51" cy="52" r="9"' + DSOFT + '/>' +
      '<rect x="64" y="60" width="14" height="10"' + DSOFT + '/><circle cx="71" cy="60" r="7"' + DSOFT + '/>' +
      '<path d="M22 70v6M38 70v4M42 70v10M60 70v6M64 70v4M78 70v4" stroke-width="1.4" opacity=".5"/>'
  };
  function destBadge(key){
    return '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="50" cy="50" r="46" fill="none" stroke-width="2"/>' +
      (DEST_SCENES[key] || "") +
      '</svg>';
  }

  function icon24(body){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + body + '</svg>';
  }
  function moodIcon(kind){
    var p = {
      candles:  '<path d="M9 21h6M12 21v-9M8 12a4 4 0 0 1 8 0c0 2.2-1.8 3-4 3s-4-.8-4-3Z" fill="currentColor" fill-opacity=".14"/><path d="M12 3c1.2 1.4 1.2 2.6 0 3.8M12 3c-1.2 1.4-1.2 2.6 0 3.8"/>',
      plugin:   '<rect x="7" y="4" width="10" height="14" rx="1.4" fill="currentColor" fill-opacity=".14"/><path d="M10 21h4M9.5 8h5M9.5 11h5"/>',
      reed:     '<path d="M9 21V7M12.4 21V5M15.8 21V9" /><ellipse cx="12" cy="21" rx="7" ry="2" fill="currentColor" fill-opacity=".12"/>',
      small:    '<rect x="8" y="9" width="8" height="10" rx="1.4" fill="currentColor" fill-opacity=".14"/><path d="M10 9V6a2 2 0 0 1 4 0v3"/><path d="M9.2 4.4c.9.9 1.7.9 2.5 0M12.9 4.4c.9.9 1.7.9 2.5 0" opacity=".5"/>',
      none:     '<circle cx="12" cy="12" r="7.6" fill="currentColor" fill-opacity=".1"/><path d="M6.9 17.1 17.1 6.9" opacity=".65"/>',
      office:   '<path d="M5 21V5h9v16" fill="currentColor" fill-opacity=".12"/><path d="M14 10h5v11" fill="currentColor" fill-opacity=".12"/>' +
                '<rect x="7.4" y="8" width="2.4" height="2.4" fill="currentColor" stroke="none"/><rect x="11" y="8" width="2.4" height="2.4" fill="currentColor" stroke="none"/>' +
                '<path d="M3 21h18"/>',
      retail:   '<path d="M6 9h12l1 12H5Z" fill="currentColor" fill-opacity=".14"/><path d="M9 9a3 3 0 0 1 6 0"/>' +
                '<path d="M4 6.6h16l-1 2.4H5Z" fill="currentColor" stroke="none"/>',
      gym:      '<path d="M4 9.6v4.8M20 9.6v4.8"/><rect x="6.4" y="7" width="2.8" height="10" rx="1" fill="currentColor" fill-opacity=".18"/>' +
                '<rect x="14.8" y="7" width="2.8" height="10" rx="1" fill="currentColor" fill-opacity=".18"/><rect x="9.2" y="11" width="5.6" height="2" fill="currentColor" stroke="none"/>',
      restaurant:'<path d="M7 3v7.4M10 3v7.4M8.5 10.4V21"/><path d="M16.4 3c1.9.6 2.4 3.4 2.4 6.2 0 1.6-.9 2.4-2.4 2.6V21"/>',
      hotel:    '<path d="M3 20v-9M3 15h18v5M21 20v-5a3 3 0 0 0-3-3h-7v3" fill="currentColor" fill-opacity=".12"/>' +
                '<circle cx="7.2" cy="12" r="2.2" fill="currentColor" stroke="none"/>',
      other:    '<rect x="3.6" y="5.6" width="16.8" height="12.8" rx="2" fill="currentColor" fill-opacity=".1"/>' +
                '<circle cx="8" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none"/>' +
                '<circle cx="16" cy="12" r="1.4" fill="currentColor" stroke="none"/>'
    };
    return icon24(p[kind]);
  }
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5 10 17.5 19 7"/></svg>';

  /* ===== DATA ===== */
  var UNITS = {
    penthouse:  {key:"penthouse",  name:"Penthouse 2.0",          cover:"1,200 sq ft",  oil:"200 mL",
                 tech:"Standalone",         install:"standalone"},
    villa:      {key:"villa",      name:"Villa 2.0",              cover:"1,800 sq ft",  oil:"500 mL",
                 tech:"Standalone or HVAC", install:"hybrid"},
    presidential:{key:"presidential",name:"Presidential 2.0",     cover:"3,000 sq ft",  oil:"500 mL",
                 tech:"HVAC-integrated",    install:"hvac"},
    doublepres: {key:"doublepres",name:"Double Presidential",     cover:"6,000+ sq ft", oil:"2 x 500 mL",
                 tech:"HVAC-integrated",    install:"hvac"}
  };

  /* Placeholder curated destination list — swap in the confirmed set from
     hotelcollection.com when available; structure (key, badge letter, color,
     mood, benefit, vocab) stays the same. */
  var DESTINATIONS = {
    amalfi:   {key:"amalfi", name:"The Amalfi Coast", colorName:"Soft Grey", color:"#9AA0A2", mood:"Effortless",
               benefit:"Citrus, sea salt and fig evoke sun-warmed stone and the coastline below.",
               vocab:["Bright","Coastal","Airy","Fresh"]},
    kyoto:    {key:"kyoto", name:"Kyoto",            colorName:"Off-White", color:"#8C8F86", mood:"Serene",
               benefit:"Green tea, bamboo and hinoki wood bring a quiet, meditative calm.",
               vocab:["Quiet","Clean","Grounded","Minimal"]},
    marrakech:{key:"marrakech", name:"Marrakech",        colorName:"Warm Grey", color:"#9C7E5F", mood:"Opulent",
               benefit:"Amber, saffron and warm spice create a rich, layered atmosphere.",
               vocab:["Warm","Spiced","Rich","Layered"]},
    aspen:    {key:"aspen", name:"Aspen",            colorName:"Rich Black", color:"#4A4546", mood:"Grounded",
               benefit:"Cedar, leather and fireside smoke bring a lodge-like warmth.",
               vocab:["Woody","Cozy","Alpine","Deep"]},
    santorini:{key:"santorini", name:"Santorini",        colorName:"Soft Grey", color:"#7E8C94", mood:"Breezy",
               benefit:"White floral and sea air give a crisp, cliffside lightness.",
               vocab:["Breezy","Floral","Marine","Light"]},
    /* open: no destination chosen — the consultant samples across the set on the call */
    unsure:   {name:"Not sure yet", colorName:"Warm Grey", color:"#A2A1A1",
               mood:"Open to guidance", open:true, spec:"GUIDE ME",
               benefit:"Your consultant will walk you through the destination set and sample it with you before you choose.",
               vocab:["Guided","Open","Sampled","Unhurried"]}
  };

  var SIZES = [
    {v:"apt",name:"Apartment",   spec:"UP TO 500 SQ FT",   desc:"Rented unit — no access to the building's HVAC",
     art:function(){return home("apt");}},
    {v:"s",  name:"Condo",       spec:"UP TO 600 SQ FT",   desc:"Owned unit, one or two bedrooms",
     art:function(){return home("s");}},
    {v:"m",  name:"Home",        spec:"UP TO 1,200 SQ FT", desc:"A standard house or townhouse",
     art:function(){return home("m");}},
    {v:"l",  name:"Large home",  spec:"UP TO 3,000 SQ FT", desc:"Multiple floors or a wide footprint",
     art:function(){return home("l");}},
    {v:"xl", name:"Estate",      spec:"UP TO 6,000 SQ FT", desc:"Large property, often zoned HVAC",
     art:function(){return home("xl");}},
    {v:"biz",name:"A property",  spec:"ANY COMMERCIAL SPACE", desc:"Boutique hotel, spa, restaurant or retail",
     biz:true, art:function(){return home("biz");}}
  ];

  var VENUES = [
    {v:"hotel", lbl:"Hotel"}, {v:"restaurant", lbl:"Restaurant"}, {v:"retail", lbl:"Retail"},
    {v:"gym", lbl:"Spa / Gym"}, {v:"office", lbl:"Office"}, {v:"other", lbl:"Other"}
  ];
  var VENUE_UNIT  = {hotel:"doublepres", restaurant:"presidential", retail:"villa", gym:"presidential", office:"villa", other:"villa"};
  var INSTALL_LABEL = {standalone:"Standalone only", hybrid:"Standalone or HVAC-integrated", hvac:"HVAC-integrated only"};
  var VENUE_LABEL = {hotel:"Hotel", restaurant:"Restaurant", retail:"Retail", gym:"Spa / Gym", office:"Office", other:"Other"};

  var USING = [
    {v:"candles", lbl:"Candles"}, {v:"plugin", lbl:"Plug-ins"}, {v:"reed", lbl:"Reeds"},
    {v:"small", lbl:"Small diffuser"}, {v:"none", lbl:"Nothing"}
  ];
  var SPEND = [
    {v:"lo", lbl:"$0–25", n:1}, {v:"mid", lbl:"$25–50", n:2},
    {v:"hi", lbl:"$50–100", n:3}, {v:"vhi", lbl:"$100+", n:4}
  ];

  var QUESTIONS = [
    {key:"sizes", title:'What are you <em>scenting</em>?', multi:true, hint:"Select all that apply"},
    {key:"method", title:'How far should it <em>spread</em>?',
     tiles:[
       {v:"hvac",  name:"Everywhere",   spec:"RUNS OFF YOUR A/C",
        desc:"Living room, bedrooms, kitchen and hallways at once",
        art:function(){return plan("hvac");}},
       {v:"key",   name:"A few rooms",  spec:"3–4 ZONES",
        desc:"Living room, primary bedroom and entryway",
        art:function(){return plan("key");}},
       {v:"one",   name:"One room",     spec:"1 ZONE",
        desc:"Just the living room, or just the bedroom",
        art:function(){return plan("one");}},
       {v:"unsure",name:"Not sure",     spec:"GUIDE ME",
        desc:"Your consultant maps the rooms with you",
        art:function(){return plan("unsure");}}
     ]},
    {key:"dest", title:'Which destination feels like <em>home</em>?', dest:true},
    {key:"__pair", title:'What do you use <em>now</em>?', pair:true},
    {key:"timeline", title:'How soon would you like to <em>get started</em>?',
     tiles:[
       {v:"today",   name:"Today",       spec:"ASAP",           art:function(){return calendar(1);}},
       {v:"asap",    name:"This week",    spec:"WITHIN 7 DAYS",  art:function(){return calendar(2);}},
       {v:"30",      name:"This month",   spec:"WITHIN 30 DAYS", art:function(){return calendar(4);}},
       {v:"90",      name:"Few months",   spec:"1–3 MONTHS",     art:function(){return calendar(9);}},
       {v:"explore", name:"Just looking", spec:"NO RUSH", wide:true, art:function(){return calendar(0);}}
     ]}
  ];

  var SIZE_LABEL = {}; SIZES.forEach(function(s){ SIZE_LABEL[s.v] = s.name; });
  var CURRENT_LABEL = {}; USING.forEach(function(u){ CURRENT_LABEL[u.v] = u.lbl; });
  var SPEND_LABEL = {}; SPEND.forEach(function(s){ SPEND_LABEL[s.v] = s.lbl; });
  var SPEND_MID = {lo:12, mid:38, hi:75, vhi:140};
  var METHOD_LABEL = {hvac:"Everywhere (HVAC)", key:"A few rooms", one:"One room", unsure:"Not sure / guide me"};
  var TIME_LABEL = {today:"Today", asap:"This week", "30":"This month", "90":"Few months", explore:"Just looking"};

  /* ===== STATE ===== */
  var state = {sizes:[], venue:null, method:null, dest:null, current:null, spend:null, timeline:null};
  var lead  = {fn:"", ln:"", em:"", ph:"", st:"", ci:"", sr:"", zp:""};
  var step = 0;

  var el = {
    aura: ROOT.querySelector("#aura"),
    rail: ROOT.querySelector("#rail"),
    quiz: ROOT.querySelector("#quiz"),
    eyebrow: ROOT.querySelector("#q-eyebrow"),
    title: ROOT.querySelector("#q-title"),
    body: ROOT.querySelector("#q-body"),
    back: ROOT.querySelector("#back"),
    cont: ROOT.querySelector("#continue"),
    reveal: ROOT.querySelector("#reveal"),
    result: ROOT.querySelector("#result")
  };

  function esc(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];
    });
  }

  function buildRail(){
    el.rail.innerHTML = "";
    for(var i=0;i<QUESTIONS.length;i++){
      var t = document.createElement("div");
      t.className = "dq-tick";
      t.innerHTML = '<span class="dq-num">' + String(i+1).padStart(2,"0") + '</span><span class="dq-bar"></span>';
      el.rail.appendChild(t);
    }
  }
  function updateRail(){
    var ticks = el.rail.querySelectorAll(".dq-tick");
    ticks.forEach(function(t, i){
      t.classList.toggle("dq-done", i < step);
      t.classList.toggle("dq-now", i === step);
    });
  }

  function isBiz(){ return state.sizes.indexOf("biz") > -1; }

  function resiSizes(){ return state.sizes.filter(function(v){ return v !== "biz"; }); }

  function installNeeded(){
    var set = [];
    resiSizes().forEach(function(v){
      if(v === "apt") set.push("standalone");
      else set.push("any");
    });
    return set;
  }

  function resiUnit(){
    var sizes = resiSizes();
    if(!sizes.length) return null;
    var tiers = {apt:1, s:1, m:2, l:3, xl:4};
    var maxTier = Math.max.apply(null, sizes.map(function(v){ return tiers[v] || 1; }));
    var hasApt = sizes.indexOf("apt") > -1;
    var byMethod = {hvac:4, key:2, one:1, unsure:2}[state.method] || 1;
    var tier = Math.max(maxTier, byMethod);
    var order = ["penthouse","villa","presidential","doublepres"];
    var unit = UNITS[order[Math.min(tier-1,3)]];
    if(hasApt && unit.install === "hvac"){
      unit = UNITS.villa; /* apartment leads never get an HVAC-only recommendation */
    }
    return unit;
  }

  function bizUnit(){
    if(!isBiz()) return null;
    var key = state.venue ? VENUE_UNIT[state.venue] : "villa";
    return UNITS[key];
  }

  function bizNoun(){
    return state.venue ? VENUE_LABEL[state.venue].toLowerCase() : "property";
  }

  function leadScore(){
    var score = 0;
    score += (SPEND.find(function(s){return s.v===state.spend;}) || {n:0}).n;
    score += {today:5, asap:4, "30":2, "90":1, explore:0}[state.timeline] || 0;
    score += resiSizes().length ? Math.min(resiSizes().length, 3) : 0;
    score += isBiz() ? 3 : 0;
    score += state.current === "none" ? 2 : 0;
    return Math.min(score, 18);
  }
  function tierOf(score){
    if(score >= 11) return {k:"hot", label:"Hot lead"};
    if(score >= 6)  return {k:"warm", label:"Warm lead"};
    return {k:"cool", label:"Standard lead"};
  }
  function callWhen(){
    return {today:"today", asap:"within the next few days", "30":"within the next couple weeks",
            "90":"in the coming weeks", explore:"whenever is convenient"}[state.timeline] || "soon";
  }

  /* ===== RENDER QUESTION ===== */
  function renderQuestion(){
    updateRail();
    var qi = effectiveIndex();
    var q = EFFECTIVE[qi];
    el.eyebrow.textContent = String(qi+1).padStart(2,"0") + " / " + String(EFFECTIVE.length).padStart(2,"0");
    el.title.innerHTML = q.title;
    el.back.hidden = qi === 0;
    el.cont.hidden = false;

    if(q.key === "sizes"){ renderSizes(q); }
    else if(q.key === "dest"){ renderDest(q); }
    else if(q.key === "__pair"){ renderPair(q); }
    else { renderTiles(q); }

    ROOT.scrollIntoView({behavior:"smooth", block:"start"});
  }

  /* build the effective question list: skip venue-only content when not biz,
     but venue chips are injected inline under the "sizes" question */
  var EFFECTIVE = QUESTIONS;
  function effectiveIndex(){ return step; }

  function tileHTML(t, cls, pressed){
    return '<button class="dq-tile ' + (cls||"") + (t.wide?" dq-wide":"") + '" type="button" data-v="' + t.v + '" ' +
      'aria-pressed="' + (pressed?"true":"false") + '">' +
      '<span class="dq-plate">' + t.art() + '</span>' +
      '<span class="dq-meta"><span class="dq-name">' + esc(t.name) + '</span>' +
      '<span class="dq-spec">' + esc(t.spec) + '</span>' +
      (t.desc ? '<span class="dq-desc">' + esc(t.desc) + '</span>' : "") + '</span>' +
      '<span class="dq-check">' + TICK + '</span>' +
      '</button>';
  }

  function renderSizes(q){
    var html = '<div class="dq-tiles" id="sizeTiles">';
    SIZES.forEach(function(s){
      html += tileHTML(s, s.biz ? "dq-biz" : "", state.sizes.indexOf(s.v) > -1);
      if(s.biz) html += '<div class="dq-venueslot" id="venueslot"></div>';
    });
    html += '</div>';
    el.body.innerHTML = html;
    renderVenueSlot();

    el.body.querySelectorAll(".dq-tile").forEach(function(btn){
      btn.addEventListener("click", function(){
        var v = btn.getAttribute("data-v");
        var idx = state.sizes.indexOf(v);
        if(idx > -1) state.sizes.splice(idx,1); else state.sizes.push(v);
        if(v === "biz" && state.sizes.indexOf("biz") === -1) state.venue = null;
        renderSizes(q);
        syncContinue();
      });
    });
    syncContinue();
  }

  function renderVenueSlot(){
    var slot = ROOT.querySelector("#venueslot");
    if(!slot) return;
    if(state.sizes.indexOf("biz") === -1){ slot.innerHTML = ""; return; }
    var html = '<div class="dq-chips dq-venue">';
    VENUES.forEach(function(v){
      html += '<button type="button" class="dq-chip" data-v="' + v.v + '" aria-pressed="' +
        (state.venue===v.v?"true":"false") + '">' + moodIcon(v.v) + '<span class="dq-cname">' + esc(v.lbl) + '</span></button>';
    });
    html += '</div>';
    slot.innerHTML = html;
    slot.querySelectorAll(".dq-chip").forEach(function(c){
      c.addEventListener("click", function(e){
        e.stopPropagation();
        state.venue = c.getAttribute("data-v");
        renderVenueSlot();
        syncContinue();
      });
    });
  }

  function renderTiles(q){
    var html = '<div class="dq-tiles">';
    q.tiles.forEach(function(t){
      html += tileHTML(t, "", state[q.key] === t.v);
    });
    html += '</div>';
    el.body.innerHTML = html;
    el.body.querySelectorAll(".dq-tile").forEach(function(btn){
      btn.addEventListener("click", function(){
        state[q.key] = btn.getAttribute("data-v");
        renderTiles(q);
        syncContinue();
      });
    });
    syncContinue();
  }

  function renderDest(q){
    var html = '<div class="dq-tiles" id="destTiles">';
    Object.keys(DESTINATIONS).forEach(function(k){
      var d = DESTINATIONS[k];
      html += '<button class="dq-tile dq-dest" type="button" data-v="' + k + '" style="--tint:' + d.color + '" ' +
        'aria-pressed="' + (state.dest===k?"true":"false") + '">' +
        '<span class="dq-plate">' + (d.open ? '<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" stroke-width="2"/><text x="50" y="60" text-anchor="middle" font-family="Barlow, sans-serif" font-weight="800" font-size="30" fill="currentColor">?</text></svg>' : destBadge(d.key)) + '</span>' +
        '<span class="dq-meta"><span class="dq-name">' + esc(d.name) + '</span>' +
        '<span class="dq-spec dq-tag-mood">' + moodIcon("hotel") + esc(d.open ? d.spec : d.mood) + '</span></span>' +
        '<span class="dq-check">' + TICK + '</span></button>';
    });
    html += '</div>';
    el.body.innerHTML = html;
    el.body.querySelectorAll(".dq-tile").forEach(function(btn){
      btn.addEventListener("click", function(){
        state.dest = btn.getAttribute("data-v");
        var d = DESTINATIONS[state.dest];
        ROOT.style.setProperty("--dest", d.color);
        ROOT.style.setProperty("--dest-wash", d.color + "22");
        renderDest(q);
        syncContinue();
      });
    });
    syncContinue();
  }

  function renderPair(q){
    var html =
      '<div class="dq-part"><p>Currently using</p><div class="dq-chips" id="usingChips">';
    USING.forEach(function(u){
      html += '<button type="button" class="dq-chip" data-v="' + u.v + '" aria-pressed="' +
        (state.current===u.v?"true":"false") + '">' + moodIcon(u.v) + '<span class="dq-cname">' + esc(u.lbl) + '</span></button>';
    });
    html += '</div></div>' +
      '<div class="dq-part"><p>Monthly spend <span class="dq-opt">(optional, helps your consultant anchor a plan)</span></p>' +
      '<div class="dq-chips dq-money" id="spendChips">';
    SPEND.forEach(function(s){
      var g = "";
      for(var i=1;i<=4;i++) g += '<i class="' + (i<=s.n?"dq-on":"") + '"></i>';
      html += '<button type="button" class="dq-chip" data-v="' + s.v + '" aria-pressed="' +
        (state.spend===s.v?"true":"false") + '"><span class="dq-amt">' + esc(s.lbl) + '</span><span class="dq-gauge">' + g + '</span></button>';
    });
    html += '</div></div>';
    el.body.innerHTML = html;

    ROOT.querySelector("#usingChips").querySelectorAll(".dq-chip").forEach(function(c){
      c.addEventListener("click", function(){ state.current = c.getAttribute("data-v"); renderPair(q); syncContinue(); });
    });
    ROOT.querySelector("#spendChips").querySelectorAll(".dq-chip").forEach(function(c){
      c.addEventListener("click", function(){ state.spend = c.getAttribute("data-v"); renderPair(q); syncContinue(); });
    });
    syncContinue();
  }

  function stepValid(){
    var q = EFFECTIVE[step];
    if(q.key === "sizes") return state.sizes.length > 0 && (!isBiz() || !!state.venue);
    if(q.key === "method") return !!state.method;
    if(q.key === "dest") return !!state.dest;
    if(q.key === "__pair") return !!state.current; /* spend optional */
    if(q.key === "timeline") return !!state.timeline;
    return true;
  }
  function syncContinue(){ el.cont.disabled = !stepValid(); }

  el.cont.addEventListener("click", function(){
    if(!stepValid()) return;
    if(step < EFFECTIVE.length - 1){ step++; renderQuestion(); }
    else { renderLeadForm(); }
  });
  el.back.addEventListener("click", function(){
    if(step > 0){ step--; renderQuestion(); }
  });

  /* ===== LEAD FORM ===== */
  function renderLeadForm(){
    el.quiz.hidden = true;
    el.reveal.hidden = false;

    var d = DESTINATIONS[state.dest];
    var twoMatches = isBiz() && resiSizes().length > 0;

    el.reveal.innerHTML =
      '<div class="dq-reveal">' +
      '<div class="dq-head"><p class="dq-eyebrow">Your destination</p>' +
      '<h2 class="dq-ask">' + (d.open
          ? 'Let&rsquo;s find your <em>destination</em> together.'
          : 'You are <em>' + esc(d.name) + '</em>.') + '</h2></div>' +
      heroHTML(d, d.open ? "Destination &middot; chosen with your consultant" : "Mood &middot; " + esc(d.mood)) +
      '<div class="dq-locked"><div class="dq-veil" aria-hidden="true">' + home("m") +
        '<div class="dq-rows"><span></span><span></span><span></span></div></div>' +
        '<div class="dq-stamp"><span>' + (twoMatches ? "Your two matches" : "Your unit match") + '</span></div></div>' +
      '<form class="dq-formwrap" id="stage1">' +
        '<h3>Unlock your match</h3><p class="dq-lede">Your details let a consultant confirm coverage for your space and route your destination match. Nothing is ordered and nothing is charged here.</p>' +
        '<ul class="dq-trust"><li>No order placed here</li><li>No payment collected</li><li>A consultant follows up personally</li></ul>' +
        '<div class="dq-fields">' +
          '<div class="dq-f"><label for="fn">First name</label><input id="fn" autocomplete="given-name"><p class="dq-err"></p></div>' +
          '<div class="dq-f"><label for="ln">Last name</label><input id="ln" autocomplete="family-name"><p class="dq-err"></p></div>' +
          '<div class="dq-f"><label for="em">Email</label><input id="em" type="email" autocomplete="email"><p class="dq-err"></p></div>' +
          '<div class="dq-f"><label for="ph">Phone</label><input id="ph" type="tel" autocomplete="tel"><p class="dq-err"></p></div>' +
          '<div class="dq-f dq-wide"><label for="st">Street address</label><input id="st" autocomplete="street-address"><p class="dq-err"></p></div>' +
          '<div class="dq-trio">' +
            '<div class="dq-f"><label for="ci">City</label><input id="ci" autocomplete="address-level2"><p class="dq-err"></p></div>' +
            '<div class="dq-f"><label for="sr">State</label><input id="sr" maxlength="2" autocomplete="address-level1"><p class="dq-err"></p></div>' +
            '<div class="dq-f"><label for="zp">ZIP</label><input id="zp" maxlength="5" autocomplete="postal-code"><p class="dq-err"></p></div>' +
          '</div>' +
          '<input class="dq-hp" type="text" name="companyName2" id="honeypot" tabindex="-1" autocomplete="off" aria-hidden="true">' +
          '<div class="dq-gcaptcha" id="recaptcha_' + cfg.sectionId + '"></div>' +
          '<p class="dq-submit-err" id="submitErr" role="alert"></p>' +
          '<button class="dq-btn dq-submit" type="submit" id="submitBtn">See my destination match</button>' +
          (cfg.consentText ? '<p class="dq-fineprint">' + cfg.consentText + '</p>' : '') +
          '<p class="dq-fineprint">This is a recommendation tool, not a checkout. Your consultant confirms placement and takes payment on a follow-up call, only if you decide to move forward.</p>' +
        '</div>' +
      '</form>' +
      '<div class="dq-nav"><button class="dq-back" id="backToQuiz" type="button">&larr; Back</button></div>' +
      '</div>';

    ROOT.querySelector("#backToQuiz").addEventListener("click", function(){
      el.reveal.hidden = true; el.quiz.hidden = false;
      step = QUESTIONS.length - 1; renderQuestion();
      ROOT.scrollIntoView({behavior:"smooth", block:"start"});
    });

    renderRecaptcha();
    /* address autocomplete lives in destination-quiz-places.js, which the section only loads when a Places API key is set */
    if(cfg.placesApiKey && typeof window.initDestinationQuizPlaces === "function"){
      window.initDestinationQuizPlaces({root: ROOT, cfg: cfg, esc: esc, track: function(name){
        try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push({event: name}); }catch(e){}
      }});
    }
    var f1 = ROOT.querySelector("#stage1");
    f1.addEventListener("input", maybeClear);
    f1.addEventListener("submit", function(e){
      e.preventDefault();
      if(!validate([
        {id:"fn", t:function(v){return v.length>=2;},                             m:"Enter your first name."},
        {id:"ln", t:function(v){return v.length>=2;},                             m:"Enter your last name."},
        {id:"em", t:function(v){return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v);}, m:"Enter a valid email."},
        {id:"ph", t:function(v){return v.replace(/\D/g,"").length>=10;},           m:"Enter a 10-digit phone number."},
        {id:"st", t:function(v){return v.length>=5;},                             m:"Enter your street address."},
        {id:"ci", t:function(v){return v.length>=2;},                             m:"Enter your city."},
        {id:"sr", t:function(v){return /^[A-Za-z]{2}$/.test(v);},                 m:"2-letter state."},
        {id:"zp", t:function(v){return /^\d{5}$/.test(v);},                       m:"Enter a 5-digit ZIP."}
      ])) return;
      ["fn","ln","em","ph","st","ci","zp"].forEach(function(k){ lead[k] = ROOT.querySelector("#" + k).value.trim(); });
      lead.sr = ROOT.querySelector("#sr").value.trim().toUpperCase();
      submitLead();
    });
  }


  /* ===== SALESFORCE SUBMISSION (same ingester + payload conventions as dynamic-form.js) ===== */
  var widgetId = null;
  function renderRecaptcha(){
    widgetId = null;
    var tryRender = function(){
      if(window.grecaptcha && grecaptcha.enterprise && typeof grecaptcha.enterprise.render === "function"){
        var host = ROOT.querySelector("#recaptcha_" + cfg.sectionId);
        if(host && widgetId === null) widgetId = grecaptcha.enterprise.render(host, {sitekey: cfg.recaptchaSiteKey});
        return true;
      }
      return false;
    };
    if(tryRender()) return;
    var t = setInterval(function(){ if(tryRender()) clearInterval(t); }, 300);
    setTimeout(function(){ clearInterval(t); }, 15000);
  }

  function unitNames(){
    var rd = resiUnit(), bd = bizUnit(), rec = [];
    if(rd) rec.push(rd.name + " (residential)");
    if(bd) rec.push(bd.name + " (commercial)");
    return rec.join(" + ");
  }

  /* human-readable summary -> Salesforce lead comments */
  function buildComments(){
    var d = DESTINATIONS[state.dest];
    var tier = tierOf(leadScore());
    var spaces = state.sizes.map(function(v){
      return v === "biz" ? ("Commercial - " + (state.venue ? VENUE_LABEL[state.venue] : "type not given")) : SIZE_LABEL[v];
    }).join(", ");
    return [
      "DESTINATION QUIZ",
      "Lead score: " + leadScore() + " of 18 (" + tier.label + ")",
      "Scenting: " + spaces,
      "Setup: " + METHOD_LABEL[state.method],
      "Destination: " + (d.open ? "Not chosen - sample full set on call" : d.name + " (" + d.mood + ")"),
      "Using now: " + CURRENT_LABEL[state.current],
      "Monthly spend: " + (state.spend ? SPEND_LABEL[state.spend] : "Not given"),
      "Timeline: " + TIME_LABEL[state.timeline],
      "Recommended: " + unitNames(),
      isBiz() ? "Route: Hotel Collection Trade (book walkthrough first)" : "",
      "",
      "CONSULTANT NOTE"
    ].concat([
      isBiz() ? "Commercial lead - book the walkthrough first; the " + (bizUnit() ? bizUnit().name : "unit") + " quote follows from square footage." : "",
      SPEND_MID[state.spend] ? "Already spends about $" + SPEND_MID[state.spend] + "/mo on " + CURRENT_LABEL[state.current].toLowerCase() + " - use as the anchor." : "",
      "No pricing was shown to the customer; present the plan and included unit on the call.",
      d.open ? "No destination chosen - open with the sampler and let them pick live." : "Pair from the destination: " + d.name + "."
    ].filter(Boolean)).join("\n");
  }

  function buildPayload(){
    var d = DESTINATIONS[state.dest];
    var tier = tierOf(leadScore());
    var p = {
      first_name: lead.fn, last_name: lead.ln, email: lead.em, phone_mobile: lead.ph,
      street: lead.st, city: lead.ci, state: lead.sr, postcode: lead.zp,
      lead_comments: buildComments(),
      lead_source: cfg.leadSource,
      lead_category: isBiz() ? cfg.leadCategoryBusiness : cfg.leadCategory,
      lead_status: cfg.leadStatus,
      business_unit: cfg.businessUnit,
      form_id: cfg.formId,   /* same field name every other lead form sends */
      formId: cfg.formId,
      referrer_url: document.referrer,
      companyName2: ROOT.querySelector("#honeypot").value,
      /* raw quiz answers, in case the ingester maps them to custom fields later */
      quiz: {
        sizes: state.sizes, venue: state.venue, method: state.method, destination: state.dest,
        destination_name: d.name || "", current: state.current, spend: state.spend, timeline: state.timeline,
        score: leadScore(), tier: tier.k, recommended: unitNames()
      }
    };
    if(typeof utilFetchCookieValue === "function"){
      p.cookies = document.cookie.replace(/"/g, '\\"');
      p.last_url = window.location.href;
      p.ga_id = utilFetchCookieValue("_ga");
      p.affiliate_id = utilFetchCookieValue("affiliate_id");
      p.affiliate_data = { page_url: utilFetchCookieValue("affiliate_data") };
      var click = typeof utilGetLatestClickID === "function" ? utilGetLatestClickID() : null;
      if(click){ p.click_id = click.clickID.value; p.platform = click.platform; }
      var map = {utm_campaign:"utm_campaign", utm_medium:"utm_medium", utm_source:"utm_source", utm_term:"utm_term",
                 utm_content:"utm_content", gclid:"shopify_gclid__c", fbclid:"facebook_fbclid", landing_url:"landing_url"};
      Object.keys(map).forEach(function(k){ p[map[k]] = utilFetchCookieValue(k); });
    }
    if(window.Shopify && Shopify.locale) p.preferred_language = Shopify.locale;
    var tok = (widgetId !== null && window.grecaptcha) ? grecaptcha.enterprise.getResponse(widgetId) : "";
    p["g-recaptcha-response"] = tok;
    return p;
  }

  function submitLead(){
    var err = ROOT.querySelector("#submitErr"), btn = ROOT.querySelector("#submitBtn");
    err.textContent = "";
    if(widgetId === null || !grecaptcha.enterprise.getResponse(widgetId)){
      err.textContent = "Please confirm you are not a robot.";
      return;
    }
    var payload = buildPayload();
    var url = cfg.formUrl + (cfg.formSource ? "?source=" + encodeURIComponent(cfg.formSource) : "");
    btn.disabled = true; btn.textContent = "Submitting...";
    fetch(url, {method:"POST", mode:"cors", headers:{"Content-Type":"application/json"}, body:JSON.stringify(payload)})
      .then(function(r){ return r.json(); })
      .then(function(data){
        if(data.status === "success"){
          if(typeof fbq === "function") fbq("track", "Lead");
          if(window.dataLayer) window.dataLayer.push({event:"destination_quiz_submit", destination:state.dest, tier:tierOf(leadScore()).k});
          if(data.lead_key && typeof utilSetCookie === "function") utilSetCookie("last_lead_key", data.lead_key, 365);
          showResult();
        } else {
          err.textContent = data.message || "Something went wrong. Please try again.";
          resetBtn();
        }
      })
      .catch(function(e){
        console.error(e);
        err.textContent = "Something went wrong. Please try again.";
        resetBtn();
      });
    function resetBtn(){
      btn.disabled = false; btn.textContent = "See my destination match";
      if(window.grecaptcha) grecaptcha.enterprise.reset(widgetId);
    }
  }

  /* the field wrapper is the nearest .dq-f (the street input may sit inside an extra autocomplete wrapper) */
  function fieldOf(i){ return i.closest ? i.closest(".dq-f") : i.parentNode; }
  function fail(i,m){ var w=fieldOf(i); w.classList.add("dq-bad"); w.querySelector(".dq-err").textContent=m; }
  function clearField(i){ var w=fieldOf(i); w.classList.remove("dq-bad"); w.querySelector(".dq-err").textContent=""; }
  function maybeClear(e){
    var w = e.target.closest ? e.target.closest(".dq-f") : null;
    if(w && w.classList.contains("dq-bad")) clearField(e.target);
  }
  function validate(checks){
    var ok = true, first = null;
    checks.forEach(function(c){
      var n = ROOT.querySelector("#" + c.id);
      if(c.t(n.value.trim())) clearField(n);
      else { fail(n,c.m); ok = false; if(!first) first = n; }
    });
    if(first) first.focus();
    return ok;
  }

  function heroHTML(d, sub){
    return '<div class="dq-hero">' +
      '<span class="dq-art">' + (d.open ? '<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" stroke-width="2"/><text x="50" y="62" text-anchor="middle" font-family="Barlow" font-weight="800" font-size="34" fill="currentColor">?</text></svg>' : destBadge(d.key)) + '</span>' +
      '<div><p class="dq-tag">' + sub + '</p><h3>' + esc(d.name) + '</h3>' +
      '<p class="dq-mood">' + esc(d.benefit) + '</p>' +
      '<ul class="dq-vocab">' + d.vocab.map(function(w){return '<li>'+esc(w)+'</li>';}).join("") + '</ul></div></div>';
  }

  function matchCard(u, isPro){
    return '<div class="dq-match' + (isPro?" dq-pro":"") + '">' +
      (isPro ? '<span class="dq-prolabel">Hotel Collection Trade</span>' : "") +
      '<span class="dq-art">' + home(isPro ? "biz" : "m") + '</span>' +
      '<p class="dq-tag">' + (isPro ? "Commercial" : "Residential") + ' match</p>' +
      '<h4>' + esc(u.name) + '</h4>' +
      '<dl><dt>Coverage</dt><dd>' + esc(u.cover) + '</dd>' +
        '<dt>Reservoir</dt><dd>' + esc(u.oil) + '</dd>' +
        '<dt>Install</dt><dd>' + esc(u.tech) + '</dd></dl>' +
      '</div>';
  }

  function showResult(){
    var d = DESTINATIONS[state.dest];
    var rd = resiUnit(), bd = bizUnit();
    var both = !!(rd && bd);
    var lead_unit = rd || bd;

    var headline = both
      ? esc(lead.fn) + ', here are your <em>two matches</em>.'
      : esc(lead.fn) + ', meet the <em>' + esc(lead_unit.name) + '</em>.';

    var coverLine =
      state.method === "hvac" ? "Wired into your air handler, it reaches every room the system serves." :
      state.method === "key"  ? "One unit placed centrally covers your entry, main room and bedroom." :
      state.method === "one"  ? "A standalone unit for your main room, movable any time." :
                                "Your consultant will confirm HVAC or standalone placement from your floor plan.";

    var cards = "";
    if(rd) cards += matchCard(rd, false);
    if(bd) cards += matchCard(bd, true);

    el.result.innerHTML =
      '<div class="dq-reveal">' +
        '<div class="dq-head"><p class="dq-eyebrow">Your match</p>' +
        '<h2 class="dq-ask">' + headline + '</h2></div>' +
        heroHTML(d, esc(lead.fn) + "&rsquo;s destination &middot; " +
          (d.open ? "chosen with your consultant" : esc(d.mood))) +
        '<div class="dq-matches' + (both ? " dq-two" : "") + '">' + cards + '</div>' +
        '<div class="dq-coverage"><span class="dq-art">' + plan(state.method === "unsure" ? "hvac" : state.method) + '</span>' +
          '<p><strong>Your coverage.</strong> ' + esc(coverLine) +
          (bd ? " Your " + esc(bizNoun()) + " is sized separately after a walkthrough." : "") +
          '</p></div>' +
        '<div class="dq-confirmed">' +
          '<h3>This is a <em>recommendation</em>, not an order.</h3>' +
          '<p>No order has been placed and no payment has been taken. Your consultant will review ' +
            (both ? 'these matches' : 'this match') + ' with you, confirm the right fit for ' +
            esc(lead.ci) + ' ' + esc(lead.sr) + ', and place the order for you once you decide to go ahead.</p>' +
        '</div>' +
        '<div class="dq-thanks">' +
          '<p class="dq-tag">Thank you, ' + esc(lead.fn) + '</p>' +
          '<h3>A scenting consultant will be <em>reaching out soon</em>.</h3>' +
          '<p class="dq-lede">Your profile is with our team now. Expect a call ' + esc(callWhen()) +
            ' on ' + esc(lead.ph) + ' &mdash; your consultant will confirm placement, walk you through your ' +
            (d.open ? "destination" : esc(d.name.toLowerCase())) + ' options and go over the plan with you.</p>' +
          '<ul class="dq-next">' +
            '<li><span>1</span>A copy of your match is on its way to ' + esc(lead.em) + '.</li>' +
            '<li><span>2</span>Your consultant confirms coverage and the right unit for your space.</li>' +
            '<li><span>3</span>If you decide to go ahead, they place the order and handle payment with you on the call.</li>' +
          '</ul>' +
        '</div>' +
        '<div id="tail"></div>' +
      '</div>';

    el.reveal.hidden = true; el.result.hidden = false;
    ROOT.scrollIntoView({behavior:"smooth", block:"start"});
    renderTail();
  }

  function renderTail(){
    ROOT.querySelector("#tail").innerHTML = '<button class="dq-restart" type="button" id="restart">Start over</button>';
    ROOT.querySelector("#restart").addEventListener("click", function(){
      state = {sizes:[], venue:null, method:null, dest:null, current:null, spend:null, timeline:null};
      lead  = {fn:"", ln:"", em:"", ph:"", st:"", ci:"", sr:"", zp:""};
      step = 0;
      ROOT.style.setProperty("--dest", "#A2A1A1");
      ROOT.style.setProperty("--dest-wash", "rgba(162,161,161,.14)");
      el.result.hidden = true; el.reveal.hidden = true; el.quiz.hidden = false;
      renderQuestion();
      ROOT.scrollIntoView({behavior:"smooth", block:"start"});
    });
  }

  buildRail();
  renderQuestion();
};
